export default __webpack_public_path__ + "static/media/7.912413a8.jpg";